export default __webpack_public_path__ + "static/inua-c16c9ef1d6faf34226eb82555355c6b6.svg";